
// initial state
const state = {
  warning: '',
  danger: '',
  success: '',
};

// getters
const getters = {
};

// actions
const actions = {
  setHttpError({ commit }, { error, text }) {
    const { status } = error.response;
    if (status !== 403 && status !== 401) {
      commit('setDangerNotification', text);
    }
  },
};

// mutations
const mutations = {
  setDangerNotification(state, playload) {
    state.danger = playload;
  },
  setWarningNotification(state, playload) {
    state.warning = playload;
  },
  setSuccessNotification(state, playload) {
    state.success = playload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js